import type {BankAccount} from "@/scripts/Common";
import { isEmpty } from "../HelperFunctions";

const createEmptyBankAccount = () => {
    const bankAccount: BankAccount = {
        id: 0,
        creditInstitute: '',
        iban: '',
        bic: '',
        accountOwnerName: ''
    }

    return bankAccount;
}

const isEmptyBankAccount = (bankAccount: BankAccount | undefined | null) => {
  return [
    bankAccount?.creditInstitute,
    bankAccount?.iban,
    bankAccount?.bic,
    bankAccount?.accountOwnerName
  ].every((value) => isEmpty(value));
}

export {
    createEmptyBankAccount,
    isEmptyBankAccount
}
